// Debug helper for billing portal issues
function checkBillingPortalDebug() {
  const debugInfo = localStorage.getItem('billingPortalDebug');
  if (debugInfo) {
    console.log('=== BILLING PORTAL DEBUG INFO ===');
    try {
      const parsed = JSON.parse(debugInfo);
      console.log(JSON.stringify(parsed, null, 2));
      return parsed;
    } catch {
      console.log('Raw debug info:', debugInfo);
      return debugInfo;
    }
  } else {
    console.log('No billing portal debug info found in localStorage');
    return null;
  }
}

// Make it available globally for easy console access
if (globalThis.window !== undefined) {
  (globalThis as any).checkBillingDebug = checkBillingPortalDebug;
}
